<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <div id="admissionMode-page" class="qi-content">
        <header>
          <h1>Forma de Ingresso</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>

        <vs-row vs-justify="left">
          <SelectedCourseBox></SelectedCourseBox>
          <SelectedOfferBox></SelectedOfferBox>
        </vs-row>

        <h3>Selecione a Forma de Ingresso do Aluno</h3>
        <vs-row v-if="admissionModeSelected">
          <vs-col vs-w="6">
            <vs-input
              name="entranceExamDate"
              type="date"
              v-model="entranceExamDate"
              :danger="!validateDate()"
              :danger-text="
                this.stepsdata.edit == true
                  ? 'Informe uma data a partir de hoje!'
                  : 'Informe uma data entre hoje e até dois dias antes da primeira aula do aluno!'
              "
              label="Data do Vestibular"
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              name="entranceExamTime"
              type="time"
              v-model="entranceExamTime"
              :danger="!validateTime()"
              danger-text="Campo obrigatório!"
              label="Horário do Vestibular"
            />
          </vs-col>
          <vs-col vs-w="12">
            <vs-button
              icon="check_circle"
              style="width: 100%"
              @click="goFoward()"
              type="filled"
              color="#139B0E"
              :disabled="
                !entranceExamDate ||
                !entranceExamTime ||
                !validateTime() ||
                !validateDate()
              "
            >
              Confirmar e Avançar
            </vs-button>
          </vs-col>
        </vs-row>
        <vs-row v-else>
          <vs-col
            vs-w="4"
            vs-xs="12"
            v-for="admissionMode in admissionModeOptions"
            :key="admissionMode.CODTIPOINGRESSO"
          >
            <vs-card class="event-admission" actionable>
              <div @click="selectAdmissionMode(admissionMode)">
                {{ admissionMode.DESCRICAO }}
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="12" vs-xs="12" v-if="this.stepsdata.edit == true">
            <vs-button
              icon="check_circle"
              style="width: 100%"
              @click="scapeAdmission()"
              type="filled"
              color="#139B0E"
            >
              Continuar sem Alterar
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import SelectedCourseBox from "../components/SelectedCourseBox.vue";
import SelectedOfferBox from "../components/SelectedOfferBox.vue";
import PreRegistrationService from "../services/preRegistration.js";
import { getStepsInformation, updateDiscussion } from "../helpers";
import moment from "moment";

export default {
  name: "AdmissionMode",
  components: {
    SelectedCourseBox,
    SelectedOfferBox,
  },
  data: () => ({
    admissionModeOptions: [],
    admissionModeSelected: null,
    error: null,
    entranceExamTime: null,
    entranceExamDate: null,
    stepsdata: null,
  }),

  mounted() {
    this.$vs.loading();
    new PreRegistrationService()
      .getAdmissionModes()
      .then((res) => {
        this.admissionModeOptions = res.data;
        this.$vs.loading.close();
      })
      .catch(() => {
        this.$vs.loading.close();
      });
  },

  created() {
    this.stepsdata = getStepsInformation();
  },

  methods: {
    selectAdmissionMode(admissionMode) {
      if (admissionMode.CODTIPOINGRESSO == "10") {
        admissionMode.entranceExamTime = "";
        admissionMode.entranceExamDate = "";
        this.admissionModeSelected = admissionMode;
      } else {
        updateDiscussion(
          `Selecionado Forma de Ingresso: ${admissionMode.DESCRICAO}`,
          {
            admissionMode,
          }
        ).finally(() => {
          if (this.stepsdata.edit == true) {
            this.$router.push("/reviewInformation");
          } else {
            this.$router.push("/financialResponsible");
          }
        });
      }
    },

    validateTime() {
      if (this.entranceExamTime == "00:00") return false;
      else return true;
    },

    validateDate() {
      if (this.stepsdata.edit == true) {
        let dateSelected = moment(this.entranceExamDate);
        let now = moment();
        if (dateSelected <= now) return false;
        return true;
      } else {
        let referenceDate = moment(this.stepsdata.classData.DTINICIAL).subtract(
          3,
          "days"
        );
        if (this.stepsdata.offer.USABO == "1") {
          referenceDate = moment(
            this.stepsdata.introductory.DTINICIAL
          ).subtract(3, "days");
        }
        let dateSelected = moment(this.entranceExamDate);
        let now = moment();
        if (dateSelected > referenceDate || dateSelected <= now) return false;
        return true;
      }
    },

    scapeAdmission() {
      this.$router.push("/reviewInformation");
    },

    goFoward() {
      let admissionMode = this.admissionModeSelected;
      admissionMode.entranceExamTime = this.entranceExamTime;
      admissionMode.entranceExamDate = this.entranceExamDate;
      updateDiscussion(
        `Selecionado Forma de Ingresso: ${admissionMode.DESCRICAO}`,
        {
          admissionMode,
        }
      ).finally(() => {
        if (this.stepsdata.edit == true) {
          this.$router.push("/reviewInformation");
        } else {
          this.$router.push("/financialResponsible");
        }
      });
    },
  },
};
</script>

<style scoped>
.event-admission {
  box-shadow: 0px 0px 2px 1px #888888 !important;
}

.event-admission:hover {
  font-weight: bold;
  box-shadow: 0px 0px 3.5px 2.5px #9b0e1c !important;
}
</style>
